import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { ClienteTienda } from "../entities/ClienteTienda";
import { ClientesTiendaRepository } from "../repositories/ClientesTiendaRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class GetAllClientesTiendaUseCase<
    T_OUT extends ClienteTienda
> extends UseCaseRecursoAsync<
    null,
    T_OUT[]
> {
    private repository: ClientesTiendaRepository<T_OUT>;
    constructor (repository: ClientesTiendaRepository<T_OUT>) {
        super();
        this.repository = repository;
    }   

    async call(input: null): Promise<Recurso<T_OUT[]>> {
        try {
            return this.repository.getAllClientesTienda();
        } catch(error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }
}